export DRAGTOUCH_THRESHOLD = 20 # pixels for distance to ignore before touch-drag start
export DRAGTOUCH_TIMEOUT = 500 # ms for time to hold before touch-drag start
